export const compile = (cb, element) => {
  if (window.MathJax && window.MathJax.Hub) {
    // Enfileira no Hub do MathJax para serializar as operações (evita corridas
    // que quebram fórmulas). Quando `element` é informado, tipografa apenas
    // aquele nó em vez do documento inteiro (muito mais rápido).
    window.MathJax.Hub.Queue([
      "Typeset",
      window.MathJax.Hub,
      element || null,
      cb,
    ]);
  }
};
